import swal from 'sweetalert';

const Swal = {
  install(Vue) {
    Vue.prototype.$swal = swal;
  },
};

export default Swal;
